import { Group, Select, Stepper, Text } from "@mantine/core";
import { IconArrowDown, IconArrowUp } from "@tabler/icons-react";
import { useMemo } from "react";
import { useLeadsSheetStore } from "../../../../../../stores/LeadsStore";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import AddNote from "../Right/activity/note/AddNote";
import TabNotesItem from "../Right/notes/TabNotesItem";

const TabNotesMobile = () => {
  const lang = useLanguage((s) => s.language);
  const current = useLeadsSheetStore((s) => s.current);
  const sort = useLeadsSheetStore((s) => s.sort);
  const setSort = useLeadsSheetStore((s) => s.setSort);

  const orders = useMemo(() => {
    return [
      {
        label: lang.prm.details.filters.desc,
        value: "desc",
      },
      {
        label: lang.prm.details.filters.asc,
        value: "asc",
      },
    ];
  }, [lang.prm.details.filters.asc, lang.prm.details.filters.desc]);

  const notes = useMemo(() => {
    if (!current?.history) {
      return [];
    }
    return current?.history?.filter((x) => !!x?.note);
  }, [current.history]);

  return (
    <>
      <Text size="lg" my={-8}>
        {lang.leads.tabs.notes}
      </Text>
      <Group mb={"lg"} justify="space-between">
        <Select
          value={sort}
          data={orders}
          w={190}
          size="xs"
          onChange={setSort}
          leftSection={
            sort === "asc" ? (
              <IconArrowUp size={18} />
            ) : (
              <IconArrowDown size={18} />
            )
          }
        />

        <AddNote isMobile />
      </Group>

      <Stepper
        active={0}
        iconSize={28}
        size="sm"
        radius={"lg"}
        styles={{ stepIcon: { border: "none", background: "none" } }}
        orientation="vertical"
      >
        {notes.map((item, index) => (
          <TabNotesItem
            key={item?.id || index}
            item={item}
            isLast={index === notes.length - 1}
            isMobile
          />
        ))}
      </Stepper>
    </>
  );
};

export default TabNotesMobile;
